import React, { useEffect } from "react";
import { useLazyLoadQuery } from "react-relay";
import { QUERY } from "./file-already-exists-checker.graphql";
import { FileAlreadyExistsCheckerProps } from "./file-already-exists-checker.types";
import { fileAlreadyExistsChecker_Query } from "../../../../__generated__/fileAlreadyExistsChecker_Query.graphql";
import { FileIsAlreadyInDBDialog } from "../FileIsAlreadyInDBDialog";

export const FileAlreadyExistsChecker = ({
	fileName,
	uploadButton,
	cancelButton,
	setOverride,
	setExistFileInDB,
}: FileAlreadyExistsCheckerProps) => {
	const query = useLazyLoadQuery<fileAlreadyExistsChecker_Query>(
		QUERY,
		{ fileName },
		{ fetchPolicy: "store-and-network" },
	);

	const isFileInDb =
		query.Admin.FileAlreadyExist.Files.map((file) => file.fileAlreadyExist).length !== 0;

	useEffect(() => {
		setExistFileInDB(isFileInDb);
	}, [isFileInDb, setExistFileInDB]);

	if (!isFileInDb) {
		return null;
	}

	return (
		<FileIsAlreadyInDBDialog
			showDialogUpload={true}
			uploadButton={uploadButton}
			setOverride={setOverride}
			cancelButton={cancelButton}
		/>
	);
};
